export type CheckoutMode = 'catalog' | 'build';

let checkoutMode: CheckoutMode = 'catalog';

export function getCheckoutMode(): CheckoutMode {
  return checkoutMode;
}

export function setCheckoutMode(mode: CheckoutMode): void {
  checkoutMode = mode === 'build' ? 'build' : 'catalog';
}

export function isBuildCheckoutMode(): boolean {
  return checkoutMode === 'build';
}
